import Axios from 'axios';

/**
 * helper function that captures Axios Cancel Errors
 * Rethrows any other error
 * @param {Error} e - thrown error
 */
const catchCancel = e => {
  if (Axios.isCancel(e) || e.name === 'AbortError') {
    // eslint-disable-next-line no-console
    if ("ALL" !== 'OFF') console.log(e.message);
  } else throw e;
};

export default catchCancel;
